import { rem } from '@Components/styles';
import styled from 'styled-components';

const LAYER_PANEL_WIDTH = 350; // matches LayersListPanel width in LayerPanel.styles.ts

type ControlsWrapperProps = {
	top: number;
	layerPanelOpen: boolean;
	// TODO: ESRI-translate — add editorOpen when the LayerProperties editor is
	// translated. Mapbox version: translateX(-width/2) panel-only, translateX(-width)
	// both open.
};

function getTransform(layerPanelOpen: boolean): string {
	if (layerPanelOpen) return `translateX(-${rem(LAYER_PANEL_WIDTH)})`;
	return 'translateX(0)';
}

export const ControlsWrapper = styled.div.attrs<ControlsWrapperProps>(props => ({
	style: {
		top: `${props.top}px`,
		transform: getTransform(props.layerPanelOpen),
	},
	id: 'esri-map-controls-container',
}))<ControlsWrapperProps>`
	transition: transform 0.5s;
	position: absolute;
	top: 0;
	right: 0;
	display: flex;
	flex-direction: column;
	padding: ${rem(10)};
	gap: ${rem(8)};
	z-index: 3;
`;
